import Vue from 'vue'
import BodyScrollLockDirective from 'v-body-scroll-lock';

Vue.use(BodyScrollLockDirective);